// @ts-nocheck — 디자인 원본 스크립트 포팅 (product2.js)
import type { Scope } from './scope';

/** 기능소개: 섹션 네비(스크롤 연동), 파이프라인 단계, 워크플로우 데모, RAG 시퀀스, 탭 전환 */
export function initProductSections(root: ParentNode, s: Scope) {
  const { setTimeout, setInterval, clearInterval, addEventListener } = s;

  // section nav
  const links = [...root.querySelectorAll('.qnav a')],
    secs = links.map((a) => root.querySelector(a.getAttribute('href')));
  let cur = -1;
  const onS = () => {
    let k = -1;
    secs.forEach((sec, i) => {
      if (sec && sec.getBoundingClientRect().top < 200) k = i;
    });
    links.forEach((a, i) => a.classList.toggle('on', i === k));
    // 모바일처럼 탭 줄이 가로로 넘칠 때 선택된 탭이 보이도록 이동
    if (k !== cur && k >= 0) {
      const a = links[k],
        bar = a.parentElement;
      if (bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: a.offsetLeft - (bar.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
    }
    cur = k;
  };
  addEventListener('scroll', onS, { passive: true });
  onS();
  links.forEach((a, i) =>
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const sec = secs[i];
      if (sec) scrollTo({ top: sec.getBoundingClientRect().top + scrollY - 120, behavior: 'smooth' });
    }),
  );

  // section nav compact
  const qn = root.querySelector('.qnav');
  if (qn) {
    const f = () => qn.classList.toggle('stk', qn.getBoundingClientRect().top <= 77 && scrollY > qn.parentElement.querySelector('.pd-hero').offsetHeight);
    addEventListener('scroll', f, { passive: true });
    f();
  }

  // pipeline steps (once)
  const st = root.querySelector('.qsteps');
  if (st) {
    const ds = [...st.querySelectorAll('div')],
      bar = st.querySelector('.bar'),
      kb = root.querySelector('.qkb');
    let done = false;
    const io = new IntersectionObserver(
      (es) => {
        if (!es[0].isIntersecting || done) return;
        done = true;
        io.disconnect();
        ds.forEach((d, j) =>
          setTimeout(() => {
            ds.forEach((x, k) => {
              x.classList.toggle('on', k <= j);
              x.classList.toggle('now', k === j);
            });
            bar.style.width = (j / (ds.length - 1)) * 86 + '%';
            if (j === ds.length - 1)
              setTimeout(() => {
                d.classList.remove('now');
                kb && kb.classList.add('hl');
              }, 600);
          }, 300 + j * 450),
        );
      },
      { threshold: 0.4 },
    );
    io.observe(st);
    s.onDispose(() => io.disconnect());
  }

  // workflow demo
  const wf = root.querySelector('.qwf');
  if (wf) {
    const $ = (q) => wf.querySelector(q),
      $$ = (q) => [...wf.querySelectorAll(q)],
      stg = $('.stg');
    const W = { w1: 'M200 60 C290 60 310 60 400 60', w2: 'M490 90 C490 160 450 220 390 220', w3: 'M300 250 C300 330 340 380 400 380' },
      svg = $('svg.wires');
    Object.entries(W).forEach(([k, d]) => {
      const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', d);
      p.setAttribute('class', 'w');
      p.dataset.w = k;
      svg.appendChild(p);
      p.style.setProperty('--len', p.getTotalLength());
    });
    const pulse = $('.pulse'),
      cur = $('.cur'),
      sT = $('.cv .st'),
      sTx = $('.cv .st b'),
      n = (k) => $('[data-n="' + k + '"]'),
      w = (k) => $('[data-w="' + k + '"]'),
      pick = $('.pal .it[data-k="ai"]'),
      msgs = $$('.chat .m');
    let T = [];
    const at = (t, f) => T.push(setTimeout(f, t)),
      status = (c, x) => {
        sT.className = 'st ' + c;
        sTx.textContent = x;
      },
      fire = (k) => {
        pulse.style.offsetPath = "path('" + W[k] + "')";
        pulse.classList.remove('go');
        void pulse.offsetWidth;
        pulse.classList.add('go');
      };
    const reset = () => {
      T.forEach((id) => window.clearTimeout(id));
      T = [];
      $$('.nd').forEach((e) => e.classList.remove('on', 'act', 'done', 'fly'));
      $$('.w').forEach((e) => e.classList.remove('on'));
      $('.pop').classList.remove('on');
      msgs.forEach((m) => m.classList.remove('on'));
      pick.classList.remove('pick');
      cur.style.opacity = 0;
      status('', '편집 중');
    };
    const play = () => {
      reset();
      at(300, () => n('n1').classList.add('on'));
      at(800, () => w('w1').classList.add('on'));
      at(1300, () => n('n2').classList.add('on'));
      at(1800, () => $('.pop').classList.add('on'));
      at(2300, () => pick.classList.add('pick'));
      at(2600, () => {
        const e = n('n3');
        e.style.transition = 'none';
        e.classList.add('on', 'fly');
        cur.style.transition = 'none';
        cur.style.transform = 'translate(-60px,60px)';
        cur.style.opacity = 1;
        void e.offsetWidth;
        e.style.transition = '';
        cur.style.transition = '';
      });
      at(2750, () => {
        n('n3').classList.remove('fly');
        cur.style.transform = 'translate(290px,222px)';
      });
      at(3700, () => {
        cur.style.opacity = 0;
        pick.classList.remove('pick');
        w('w2').classList.add('on');
      });
      at(4100, () => w('w3').classList.add('on'));
      at(4400, () => n('n4').classList.add('on'));
      at(5100, () => {
        status('run', '실행 중');
        msgs[0].classList.add('on');
        n('n1').classList.add('act');
      });
      at(5500, () => fire('w1'));
      at(6200, () => {
        n('n1').classList.replace('act', 'done');
        n('n2').classList.add('act');
        msgs[1].classList.add('on');
      });
      at(6900, () => fire('w2'));
      at(7600, () => {
        n('n2').classList.replace('act', 'done');
        n('n3').classList.add('act');
        msgs[1].classList.remove('on');
        msgs[2].classList.add('on');
      });
      at(8300, () => fire('w3'));
      at(9000, () => {
        n('n3').classList.replace('act', 'done');
        n('n4').classList.add('act');
        msgs[2].classList.remove('on');
      });
      at(9400, () => {
        msgs[3].classList.add('on');
        n('n4').classList.replace('act', 'done');
        status('done', '실행 완료');
      });
    };
    $('.replay').addEventListener('click', play);
    const wio = new IntersectionObserver(
      (es) => {
        if (es[0].isIntersecting) {
          wio.disconnect();
          play();
        }
      },
      { threshold: 0.35 },
    );
    wio.observe(wf);
    s.onDispose(() => wio.disconnect());
    const cv = stg.parentElement,
      fit = () => {
        if (!cv.clientWidth) return;
        stg.style.transform = 'scale(' + Math.max(0.3, Math.min(1, (cv.clientWidth - 24) / 600, (cv.clientHeight - 90) / 440)) + ')';
      };
    fit();
    addEventListener('resize', fit);
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(fit);
      ro.observe(cv);
      s.onDispose(() => ro.disconnect());
    }
  }

  // rag sequence
  const ch = root.querySelector('.qchat');
  if (ch) {
    const sp = [...ch.querySelectorAll('.sp span')],
      an = ch.querySelector('.an'),
      dc = ch.querySelector('.doc3');
    let t = 0,
      vis = false;
    const vio = new IntersectionObserver(
      (es) => {
        vis = es[0].isIntersecting;
      },
      { threshold: 0.3 },
    );
    vio.observe(ch);
    s.onDispose(() => vio.disconnect());
    setInterval(() => {
      if (!vis) return;
      t = (t + 1) % 8;
      sp.forEach((el, j) => el.classList.toggle('on', t > j));
      an.classList.toggle('on', t >= 4);
      dc.classList.toggle('on', t >= 5);
    }, 900);
  }

  // center illus vertically (equal top/bottom gap)
  const cen = () =>
    root.querySelectorAll('.qcd .il').forEach((il) => {
      if (!il.offsetHeight || il.closest('.qsw')) return;
      const ks = [...il.children];
      ks.forEach((k) => (k.style.translate = ''));
      const r = il.getBoundingClientRect();
      let t = 1e9,
        b = -1e9;
      ks.forEach((k) => {
        const q = k.getBoundingClientRect();
        if (!q.height) return;
        t = Math.min(t, q.top - r.top);
        b = Math.max(b, q.bottom - r.top);
      });
      if (t > b) return;
      const d = Math.round((r.height - (b - t)) / 2 - t);
      ks.forEach((k) => (k.style.translate = d ? '0 ' + d + 'px' : ''));
    });
  cen();
  addEventListener('load', cen);
  addEventListener('resize', cen);
  document.fonts && document.fonts.ready.then(cen);
  root.querySelectorAll('.qtabs button').forEach((b) => b.addEventListener('click', () => requestAnimationFrame(cen)));

  // rag side switcher
  const sw = root.querySelector('.qsw');
  if (sw) {
    const rs = [...sw.querySelectorAll('.qrow [data-v]')],
      vs = [...sw.querySelectorAll('.qv')];
    let k = 2,
      tm;
    const setV = (v) => {
      k = v;
      rs.forEach((r) => r.classList.toggle('on', +r.dataset.v === v));
      vs.forEach((x) => x.classList.toggle('on', +x.dataset.v === v));
    };
    const auto = () => {
      clearInterval(tm);
      tm = setInterval(() => setV((k % 3) + 1), 3200);
    };
    rs.forEach((r) => {
      r.addEventListener('mouseenter', () => {
        clearInterval(tm);
        setV(+r.dataset.v);
      });
      r.addEventListener('click', () => setV(+r.dataset.v));
    });
    sw.addEventListener('mouseleave', auto);
    setV(1);
    auto();
  }

  // admin tabs
  root.querySelectorAll('.qtabs button').forEach((b) =>
    b.addEventListener('click', () => {
      root.querySelectorAll('.qtabs button').forEach((x) => x.classList.toggle('on', x === b));
      root.querySelectorAll('.qpane').forEach((p) => p.classList.toggle('on', p.dataset.p === b.dataset.p));
    }),
  );
}
